import { LitElement, html, svg } from 'lit';

export class IconSearch16 extends LitElement {
  render() { return html`<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16"><title>Forstørrelsesglass</title><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8.796 11.803A5.684 5.684 0 1 0 4.349 1.341a5.684 5.684 0 0 0 4.447 10.462ZM11 11l4 4"></path></svg>`; }
}
if (!customElements.get('f-icon-search16', IconSearch16)) {
  customElements.define('f-icon-search16', IconSearch16);
}